export default {
    NO_DATA_TEXT: "Записи пользовательских действий отсутствуют",
    USER_NAME: "Пользовать",
    SOURCE: "Источник",
    ACTION_TYPE: "Тип события",
    CREATED: "Дата и время",
    RECORD: "Запись",
    PROJECT: "Проект",
    FILTER_PLACEHOLDER: "Поиск"
};
